module.exports = __webpack_public_path__ + "img/img_32418_0_13.396782bb.png";